import React from "react";

const Email = ({ size = 40, color = "#1E273B" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37 19H23C21.6744 19.0016 20.4036 19.5289 19.4662 20.4662C18.5289 21.4036 18.0016 22.6744 18 24V36C18.0016 37.3256 18.5289 38.5964 19.4662 39.5338C20.4036 40.4711 21.6744 40.9984 23 41H37C38.3256 40.9984 39.5964 40.4711 40.5338 39.5338C41.4711 38.5964 41.9984 37.3256 42 36V24C41.9984 22.6744 41.4711 21.4036 40.5338 20.4662C39.5964 19.5289 38.3256 19.0016 37 19ZM23 21H37C37.5988 21.0012 38.1835 21.1815 38.679 21.5178C39.1744 21.8541 39.5579 22.3309 39.78 22.887L32.122 30.546C31.5584 31.1073 30.7954 31.4225 30 31.4225C29.2046 31.4225 28.4416 31.1073 27.878 30.546L20.22 22.887C20.4421 22.3309 20.8256 21.8541 21.321 21.5178C21.8165 21.1815 22.4012 21.0012 23 21ZM37 39H23C22.2044 39 21.4413 38.6839 20.8787 38.1213C20.3161 37.5587 20 36.7956 20 36V25.5L26.464 31.96C27.4026 32.8963 28.6743 33.422 30 33.422C31.3257 33.422 32.5974 32.8963 33.536 31.96L40 25.5V36C40 36.7956 39.6839 37.5587 39.1213 38.1213C38.5587 38.6839 37.7956 39 37 39Z"
        fill={color}
      />
    </svg>
  );
};

export default Email;
